<template>
  <ul class="dropdown">
    <li class="dropdown-item">
      <a href="#">
        <span class="d-flex justify-content-between align-items-center"> {{ selectedValue }} <i
            class="fas fa-angle-down"></i> </span>
      </a>
      <ul v-for="item in locationList" :key="item.selectedLocation" @mouseleave="hideDropdown">
        <ul class="sub-dropdown" v-if="item.options">
          <li class="sub-dropdown-item" v-for="subItem in item.options" :key="subItem.organization_id">
            <a href="#">
              {{ subItem.organization_name }}
            </a>
            <ul class="nested-sub-dropdown" v-if="subItem.locations">
              <li v-for="nestedItem in subItem.locations" :key="nestedItem.location_id">
                <a href="#" @click="selectItem(nestedItem)">{{ nestedItem.location_name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </ul>

    </li>
  </ul>
</template>

<script>
import { getLocationId } from '../../utils/SessionDataHandler';

export default {
  data() {
    return {
      locationList: [],
      selectedValue: '',
      isDropdownVisible: false,
    };
  },
  props: ["dropdownList"],
  methods: {
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    hideDropdown() {
      this.isDropdownVisible = false;
    },
    selectItem(item) {
      console.log("Dropdown: selectItem called with:", item);
      this.selectedValue = item?.location_name;
      const locationId = item?.location_id;
      console.log("Dropdown: Emitting selectedValue with locationId:", locationId);
      this.$emit('selectedValue', locationId);
      this.hideDropdown();
    },
    setSelectedValue() {
      // if (this.$cookies?.isKey('cslocationid')) {
      //   this.selectedValue = this.dropdownList
      //     ?.map(org => org.locations.find(loc => loc.location_id == String(this.$cookies?.get('cslocationid'))))
      //     .find(loc => loc !== undefined)?.location_name;
      // } else {
      //   this.selectedValue = this.dropdownList[0]?.organization_name;
      // }

      //currently fetching locationID from localStorage, (cookie - remaining)

      // Get locationId from localStorage
      const locationId = getLocationId();
      
      // If no locationId, show first organization name
      if (!locationId) {
        this.selectedValue = this.dropdownList?.[0]?.organization_name || '';
        return;
      }

      // If dropdownList is not available or empty, can't set selected value
      if (!this.dropdownList || this.dropdownList.length === 0) {
        return;
      }

      // Find the location in the dropdownList structure
      const locationIdString = String(locationId);
      
      // Search through all organizations and their locations
      for (const org of this.dropdownList) {
        if (org.locations && Array.isArray(org.locations)) {
          const foundLocation = org.locations.find(
            loc => String(loc.location_id) === locationIdString
          );
          
          if (foundLocation && foundLocation.location_name) {
            this.selectedValue = foundLocation.location_name;
            console.log("Location found and set:", foundLocation.location_name, "for locationId:", locationIdString);
            return;
          }
        }
      }
      
      // If location not found, fallback to first organization name
      console.warn("Location not found in dropdownList for locationId:", locationIdString, "dropdownList:", this.dropdownList);
      this.selectedValue = this.dropdownList[0]?.organization_name || '';
    },
    updateLocationList() {
      this.locationList = [
        {
          selectedLocation: this.selectedValue,
          options: this.dropdownList,
        },
      ];
    },
  },
  watch: {
    dropdownList: {
      handler(newList) {
        this.updateLocationList();
        // Use nextTick to ensure dropdownList is fully processed
        this.$nextTick(() => {
          // Only set selected value if dropdownList is populated
          if (newList && newList.length > 0) {
            this.setSelectedValue();
          }
        });
      },
      deep: true, // Watch nested changes
      immediate: true, // Run immediately when component is created
    },
  },
  mounted() {
    this.updateLocationList(); // Initial setup
    // Use nextTick to ensure dropdownList is available
    this.$nextTick(() => {
      if (this.dropdownList && this.dropdownList.length > 0) {
        this.setSelectedValue();
      }
    });
    
    // Listen for storage events (when localStorage changes from SignIn modal)
    this.storageListener = (e) => {
      if (e.key === 'sessionData' && e.newValue) {
        // Location was updated in localStorage, refresh the selected value
        this.$nextTick(() => {
          if (this.dropdownList && this.dropdownList.length > 0) {
            this.setSelectedValue();
          }
        });
      }
    };
    window.addEventListener('storage', this.storageListener);
    
    // Also listen for custom event for same-window localStorage updates
    // (storage event only fires for changes from other windows/tabs)
    this.customStorageListener = () => {
      this.$nextTick(() => {
        if (this.dropdownList && this.dropdownList.length > 0) {
          this.setSelectedValue();
        }
      });
    };
    window.addEventListener('locationUpdated', this.customStorageListener);
  },
  updated() {
    // Re-check selected value when component updates (e.g., when key changes)
    if (this.dropdownList && this.dropdownList.length > 0) {
      this.$nextTick(() => {
        this.setSelectedValue();
      });
    }
  },
  beforeUnmount() {
    // Clean up event listeners
    if (this.storageListener) {
      window.removeEventListener('storage', this.storageListener);
    }
    if (this.customStorageListener) {
      window.removeEventListener('locationUpdated', this.customStorageListener);
    }
  },
};
</script>


<style scoped>
.dropdown {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  border: 1px solid gray;
  border-radius: 3px;
  width: 100%;
  z-index: 1;
}

.dropdown-item {
  position: relative;
}

.dropdown-item a {
  text-decoration: none;
  display: block;
}

.sub-dropdown,
.nested-sub-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  list-style-type: none;
  padding: 10px;
  margin: 0;
  border: 1px solid gray;
  background-color: white;
  width: 100%;
  border-radius: 4px;
  z-index: 1050;
}

.sub-dropdown-item {
  position: relative;
}

.sub-dropdown-item:hover .nested-sub-dropdown {
  display: block;
  left: 100%;
  top: 0;
}

.dropdown-item:hover .sub-dropdown {
  display: block;
}

/* Mobile responsive styles - make dropdown absolute */
@media (max-width: 767.98px) {
  .dropdown {
    position: relative;
    z-index: 1000;
  }
  
  .sub-dropdown,
  .nested-sub-dropdown {
    position: absolute;
    min-width: 200px;
    width: max-content;
    max-width: calc(100vw - 20px);
    z-index: 1050;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .nested-sub-dropdown {
    left: 100%;
    top: 0;
  }
}
</style>